import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

import type { Flow } from "./types";

export const FlowContext = createContext<Flow>("mobile");

interface ClientInterfaceProviderProps {
  flow: Flow;
  children: ReactNode;
}

export const FlowProvider = ({
  flow,
  children,
}: ClientInterfaceProviderProps) => (
  <FlowContext.Provider value={flow}>{children}</FlowContext.Provider>
);

export const useFlow = () => {
  return useContext(FlowContext);
};
